import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-back-arrow",
  "use": "icon-back-arrow-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol viewBox=\"0 0 15 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-back-arrow\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.5 6.625H3.825L8.725 1.725L7.5 0.5L0.5 7.5L7.5 14.5L8.725 13.275L3.825 8.375H14.5V6.625Z\" fill=\"#917F81\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol